var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { addMonths, subMonths, isSameMonth } from 'date-fns';
import { StateContext, DispatchContext } from './DatePickerContext';
import * as actionTypes from '../reducer/actionTypes';
import { isFunction } from '../helpers/function';
var DatePickerButton = function (_a) {
  var children = _a.children,
    updateMonth = _a.updateMonth,
    props = __rest(_a, ["children", "updateMonth"]);
  var dispatch = React.useContext(DispatchContext);
  var _b = React.useContext(StateContext),
    year = _b.year,
    month = _b.month,
    selectedDate = _b.selectedDate,
    allowCellFocus = _b.allowCellFocus;
  var setFocus = function (date) {
    if (!allowCellFocus) {
      dispatch({
        type: actionTypes.ALLOW_CELL_FOCUS
      });
    }
    dispatch({
      type: actionTypes.SET_FOCUSSED_DATE,
      payload: isSameMonth(date, selectedDate) ? selectedDate : date
    });
  };
  var prev = function () {
    dispatch({
      type: actionTypes.DECREMENT_MONTH
    });
    setFocus(subMonths(new Date(year, month), 1));
  };
  var next = function () {
    dispatch({
      type: actionTypes.INCREMENT_MONTH
    });
    setFocus(addMonths(new Date(year, month), 1));
  };
  var userOnClick = props.onClick,
    rest = __rest(props, ["onClick"]);
  var render = function () {
    return React.createElement("button", __assign({
      type: 'button',
      onClick: function (event) {
        if (isFunction(userOnClick)) {
          userOnClick(event);
        }
        updateMonth({
          prev: prev,
          next: next
        });
      }
    }, rest), children);
  };
  return React.useMemo(render, [children, updateMonth, year, month, selectedDate, allowCellFocus, dispatch].concat(Object.keys(props)));
};
export default DatePickerButton;